// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"37b44824","455":"189eb1cd","977":"e0a61454"}[chunkId] + ".chunk.js";
};